<script>
  import { onMount } from "svelte";
  import Header from "../components/Header.svelte";
  import maplibregl from "maplibre-gl";
  import Notification from "../components/Notification.svelte";
  import { operations } from "maplibre-gl";
  import Confirmation from "../components/Confirmation.svelte";

  let showMap = false;

  let showConfirmation = false;
  let confirmationMessage = "";
  let deletionCallback = null;

  let modalOpen = false;

  let showEditModal = false;
  let editText = "";
  let editType = "";
  let editCommentId = "";
  let editReplyId = "";

  let subscriberCount = 0;
  let aliasSubscriberCount = 0;
  let isSubscribed = false;
  let isAliasSubscribed = false;
  let showUnsubscribeConfirmation = false;

  function openEditModal(type, commentId, reply = null) {
    editType = type;
    editText = type === "comment" ? commentId.text : reply.text;
    editCommentId = commentId;
    editReplyId = reply ? reply._id : null;
    // console.log(editCommentId);
    // console.log(editReplyId);
    showEditModal = true;
  }

  function closeEditModal() {
    showEditModal = false;
    editText = "";
    editType = "";
    editCommentId = "";
    editReplyId = "";
  }

  async function submitEdit() {
    try {
      const url = editType === "comment" ? "/edit" : "/reply/edit";
      const body =
        editType === "comment"
          ? { commentId: editCommentId, newText: editText }
          : {
              commentId: editCommentId,
              replyId: editReplyId,
              newText: editText,
            };

      const response = await fetch(
        `https://api.trulens.ae/api/comments${url}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: userData.token,
          },
          body: JSON.stringify(body),
        }
      );

      if (response.ok) {
        fetchCommentsReplies();
        closeEditModal();
      } else {
        // console.error("Failed to edit comment/reply:", response.statusText);
      }
    } catch (error) {
      // console.error("Error editing comment/reply:", error);
    }
  }

  function toggleComments() {
    modalOpen = !modalOpen;
    const commentsSection = document.getElementById("comments-section");
    if (commentsSection) {
      commentsSection.scrollIntoView({ behavior: "smooth" });
    }
  }

  let userData = null;
  export let videoId;
  let videos = [];
  let video = null;
  let map = null;
  let showFullDescription = false;
  let hasLiked = false;
  let likeCount = 0;
  let newComment = "";
  let comments = [];

  let page = 1;
  let loading = false;
  let noMoreComments = false;

  let showShareModal = false;
  let videoUrl = "";

  function toggleShareModal() {
    showShareModal = !showShareModal;
    if (showShareModal) {
      videoUrl = window.location.href;
    }
  }

  let showNotification = false;

  let message = "";

  async function copyVideoLink() {
    try {
      await navigator.clipboard.writeText(videoUrl);
      message = "Video URL copied to clipboard!";
      showNotification = true;
      setTimeout(() => (showNotification = false), 3000);
    } catch (error) {
      // console.error("Error copying video URL:", error);
      message = "Failed to copy video URL to clipboard.";
      showNotification = true;
      setTimeout(() => (showNotification = false), 3000);
    }
  }

  async function copyVideoLink2() {
    try {
      if (video && video._id) {
        const customURL = `https://api.trulens.ae/download/${video._id}`;
        await navigator.clipboard.writeText(customURL);
        message = "Custom URL copied to clipboard!";
        showNotification = true;
        setTimeout(() => (showNotification = false), 3000);
      } else {
        throw new Error("Post ID not available.");
      }
    } catch (error) {
      message = "Failed to copy custom URL to clipboard.";
      showNotification = true;
      setTimeout(() => (showNotification = false), 3000);
    }
  }

  async function addComment() {
    try {
      const response = await fetch("https://api.trulens.ae/api/comments/add", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: userData.token,
        },
        body: JSON.stringify({ videoId, text: newComment }),
      });
      if (response.ok) {
        fetchCommentsReplies();

        newComment = "";
      } else {
        // console.error("Failed to add comment:", response.statusText);
      }
    } catch (error) {
      // console.error("Error adding comment:", error);
    }
  }

  async function fetchCommentsReplies() {
    try {
      const response = await fetch(
        `https://api.trulens.ae/api/comments/video/${videoId}?_=${Date.now()}`
      );
      const data = await response.json();
      comments = data;
    } catch (error) {
      // console.error("Error fetching comments:", error);
    }
  }

  async function fetchComments(reset = false) {
    if (loading || noMoreComments) return;
    loading = true;

    try {
      const response = await fetch(
        `https://api.trulens.ae/api/comments/video/site/${videoId}?page=${page}&limit=2&_=${Date.now()}`
      );
      const data = await response.json();

      if (reset) {
        comments = data;
        page = 2;
      } else {
        if (data.length === 0) {
          noMoreComments = true;
        } else {
          comments = [...comments, ...data];
          page++;
        }
      }
    } catch (error) {
      // console.error("Error fetching comments:", error);
    }

    loading = false;
  }

  function handleScroll() {
    const bottomReached =
      window.innerHeight + window.scrollY >= document.body.offsetHeight;
    if (bottomReached) {
      fetchComments();
    }
  }

  onMount(() => {
    window.addEventListener("scroll", handleScroll);
    fetchComments();
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  });

  let relatedVideosMessage = "";

  async function fetchRelatedVideos() {
    try {
      const response = await fetch(
        `https://api.trulens.ae/api/videos/related/${videoId}?_=${Date.now()}`
      );
      const data = await response.json();

      // Filter out videos with isNamePrivate set to true
      return data.filter((video) => !video.isNamePrivate);
    } catch (error) {
      return [];
    }
  }

  async function fetchAliasRelatedVideos() {
    try {
      const response = await fetch(
        `https://api.trulens.ae/api/videos/alias-related/${video.alternateName}?excludeId=${video._id}&_=${Date.now()}`
      );
      const data = await response.json();

      if (data.message) {
        relatedVideosMessage = data.message;
        return [];
      }
      return data;
    } catch (error) {
      relatedVideosMessage = "Error fetching related videos.";
      return [];
    }
  }

  $: if (video) {
    (async () => {
      if (!video.isNamePrivate) {
        videos = await fetchRelatedVideos();
      } else {
        videos = await fetchAliasRelatedVideos();
      }
    })();
  }

  async function fetchVideoData() {
    try {
      const response = await fetch(
        `https://api.trulens.ae/api/videos/data/${videoId}?_=${Date.now()}`
      );
      video = await response.json();
      // console.log(video);

      if (video.isNamePrivate && video.alternateName) {
        await fetchSubscriberCountByAlternateName(video.alternateName);
      }

      // Check the isLocationExcluded property to control map visibility
      showMap = !video.isLocationExcluded;

      // console.log(showMap);
    } catch (error) {
      // console.error("Error fetching video data:", error);
    }
  }

  let isCheckingSubscription = true;

  async function checkSubscriptionStatus() {
    isCheckingSubscription = true;
    try {
      if (video.isNamePrivate && video.alternateName) {
        await checkAliasSubscriptionStatus(video.alternateName);
      } else {
        await checkRegularSubscriptionStatus();
      }
    } catch (error) {
      console.error("Error checking subscription status:", error);
    } finally {
      isCheckingSubscription = false;
    }
  }

  async function checkAliasSubscriptionStatus(alternateName) {
    try {
      const response = await fetch(
        `https://api.trulens.ae/api/subscribe/subscriptions?_=${Date.now()}`,
        {
          method: "GET",
          headers: {
            Authorization: userData.token,
          },
        }
      );

      if (response.ok) {
        const subscriptions = await response.json();
        // console.log(subscriptions);

        // Check if the alternateName exists in the subscriptions array (case-insensitive)
        isSubscribed = subscriptions.alternateNameSubscriptions.some(
          (subscription) =>
            subscription.alternateName.toLowerCase() ===
            alternateName.toLowerCase()
        );

        if (isSubscribed) {
          // console.log(
          //   "User is subscribed to the alternate name:",
          //   alternateName
          // );
        } else {
          // console.log(
          //   "User is not subscribed to the alternate name:",
          //   alternateName
          // );
        }
      } else {
        // console.error("Failed to fetch subscriptions:", response.statusText);
      }
    } catch (error) {
      // console.error("Error fetching subscriptions:", error);
    }
  }

  async function checkRegularSubscriptionStatus() {
    try {
      const response = await fetch(
        `https://api.trulens.ae/api/subscribe/subscriptions?_=${Date.now()}`,
        {
          method: "GET",
          headers: {
            Authorization: userData.token,
          },
        }
      );

      if (response.ok) {
        const subscriptions = await response.json();
        // Check if video.userId exists in the subscriptions array
        isSubscribed = subscriptions.userSubscriptions.some(
          (subscription) => subscription._id === video.userId
        );
      } else {
        // console.error("Failed to fetch subscriptions:", response.statusText);
      }
    } catch (error) {
      // console.error("Error fetching subscriptions:", error);
    }
  }

  async function addSubscription() {
    try {
      const response = await fetch(
        `https://api.trulens.ae/api/subscribe/add?_=${Date.now()}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: userData.token,
          },
          body: JSON.stringify({ subscribedToId: video.userId }),
        }
      );
      if (response.ok) {
        isSubscribed = true; // Update the status
        await fetchSubscriberCount();
      } else {
        // console.error("Failed to subscribe:", response.statusText);
      }
    } catch (error) {
      // console.error("Error subscribing:", error);
    }
  }

  async function removeSubscription() {
    try {
      const response = await fetch(
        `https://api.trulens.ae/api/subscribe/remove?_=${Date.now()}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: userData.token,
          },
          body: JSON.stringify({ subscribedToId: video.userId }),
        }
      );
      if (response.ok) {
        isSubscribed = false; // Update the status
        await fetchSubscriberCount();
      } else {
        // console.error("Failed to unsubscribe:", response.statusText);
      }
    } catch (error) {
      // console.error("Error unsubscribing:", error);
    }
  }

  async function removeAliasSubscription() {
    try {
      const response = await fetch(
        `https://api.trulens.ae/api/subscribe/remove-alias?_=${Date.now()}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: userData.token,
          },
          body: JSON.stringify({ alternateName: video.alternateName }),
        }
      );
      if (response.ok) {
        isSubscribed = false; // Update the status
        await fetchSubscriberCountByAlternateName(video.alternateName);
      } else {
        // console.error("Failed to unsubscribe:", response.statusText);
      }
    } catch (error) {
      // console.error("Error unsubscribing:", error);
    }
  }

  async function addAliasSubscription() {
    // console.log(video.alternateName);
    try {
      const response = await fetch(
        `https://api.trulens.ae/api/subscribe/add-alias?_=${Date.now()}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: userData.token,
          },
          body: JSON.stringify({ alternateName: video.alternateName }),
        }
      );
      if (response.ok) {
        isSubscribed = true;
        await fetchSubscriberCountByAlternateName(video.alternateName);
      } else {
        // console.error("Failed to subscribe:", response.statusText);
      }
    } catch (error) {
      // console.error("Error subscribing:", error);
    }
  }

  async function fetchSubscriberCount() {
    //console.log("user id " + video.userId);
    try {
      const response = await fetch(
        `https://api.trulens.ae/api/subscribe/count/${video.userId}?_=${Date.now()}`
      );
      if (response.ok) {
        const data = await response.json();
        subscriberCount = data.subscriberCount;
        // console.log(subscriberCount);
      } else {
        // console.error("Failed to fetch subscriber count:", response.statusText);
      }
    } catch (error) {
      // console.error("Error fetching subscriber count:", error);
    }
  }

  async function fetchSubscriberCountByAlternateName(alternateName) {
    try {
      const response = await fetch(
        `https://api.trulens.ae/api/subscribe/count-alias/${alternateName}?_=${Date.now()}`
      );
      if (response.ok) {
        const data = await response.json();
        aliasSubscriberCount = data.aliasSubscriberCount;
      } else {
        // console.error(
        //   "Failed to fetch subscriber count by alternate name:",
        //   response.statusText
        // );
      }
    } catch (error) {
      // console.error(
      //   "Error fetching subscriber count by alternate name:",
      //   error
      // );
    }
  }

  async function fetchLikeCount() {
    try {
      const response = await fetch(
        `https://api.trulens.ae/api/likes/count/${videoId}?_=${Date.now()}`
      );
      const data = await response.json();
      likeCount = data.likeCount;
    } catch (error) {
      // console.error("Error fetching like count:", error);
    }
  }

  async function checkIfLikedByUser() {
    try {
      const response = await fetch(
        `https://api.trulens.ae/api/likes/liked/${videoId}?_=${Date.now()}`,
        {
          method: "GET",
          headers: {
            Authorization: userData.token,
          },
        }
      );
      if (response.ok) {
        const data = await response.json();
        hasLiked = data.liked;
      } else {
        // console.error("Failed to check if liked by user:", response.statusText);
      }
    } catch (error) {
      // console.error("Error checking if liked by user:", error);
    }
  }

  let mediaType = "";
  onMount(() => {
    userData = JSON.parse(localStorage.getItem("userData"));
    fetchVideoData().then(() => {
      if (video) {
        mediaType = video.mimeType.split("/")[0];
        initializeMap();
        checkSubscriptionStatus();
        fetchSubscriberCount();
      }
    });
    fetchLikeCount();
    checkIfLikedByUser();
  });

  onMount(() => {
    if (mediaType === "image") {
      checkImageOrientation(video.downloadURL);
    } else if (mediaType === "video") {
      checkVideoOrientation(video.downloadURL);
    }
  });

  function checkImageOrientation(imageSrc) {
    const img = new Image();
    img.src = imageSrc;
    img.onload = () => {
      EXIF.getData(img, function () {
        const orientation = EXIF.getTag(this, "Orientation");
        if (orientation === 6 || orientation === 8) {
          document.querySelector(".main-image").classList.add("rotate-90");
        }
      });
    };
  }

  function checkVideoOrientation(videoSrc) {
    const video = document.createElement("video");
    video.src = videoSrc;
    video.onloadedmetadata = () => {
      if (video.videoWidth < video.videoHeight) {
        document.querySelector(".main-video").classList.add("rotate-90");
      }
    };
  }

  // onMount(async () => {
  //   for (let video of videos) {
  //     const mimeResponse = await fetch(
  //       `https://api.trulens.ae/api/videos/mime/${video._id}?_=${Date.now()}`
  //     );
  //     if (mimeResponse.ok) {
  //       const mimeType = await mimeResponse.text();
  //       video.mimeType = mimeType;
  //     } else {
  //       // console.error(
  //       // `Failed to fetch mime type for video ID: ${video._id}. Status: ${mimeResponse.status} ${mimeResponse.statusText}`
  //       // );
  //     }
  //   }
  // });

  // onMount(() => {
  //   userData = JSON.parse(localStorage.getItem("userData"));
  //   fetchVideoData().then(() => {
  //     if (video) {
  //       initializeMap();
  //     }
  //   });
  //   fetchLikeCount();
  //   checkIfLikedByUser();
  // });

  async function playVideo(videoId) {
    window.location.href = `#/video/${videoId}`;
    // navigate(`#/video/${videoId}`);
    window.location.reload();
  }

  function handleVideoClick(video) {
    playVideo(video._id);
  }

  function initializeMap() {
    const mapContainer = document.getElementById("map");

    if (showMap) {
      // Initialize map when location is available
      if (mapContainer && video) {
        map = new maplibregl.Map({
          container: "map",
          style:
            "https://api.maptiler.com/maps/23dcaeeb-8b75-450b-990c-778aaf087f1e/style.json?key=vIljITtCdwhZcKweYUVg",
          center: [video.longitude, video.latitude],
          zoom: 14,
        });

        new maplibregl.Marker()
          .setLngLat([video.longitude, video.latitude])
          .addTo(map);
      } else {
        // console.error("Map container or video data not found");
      }
    } else {
      // If no location, show a message instead of the map
      if (mapContainer) {
        mapContainer.innerHTML = "<h3>No location available to display.</h3>";
        mapContainer.style.textAlign = "center";
        mapContainer.style.display = "flex";
        mapContainer.style.justifyContent = "center";
        mapContainer.style.alignItems = "center";
        mapContainer.style.height = "400px"; // Make sure the container has a height for the message
      }
    }
  }

  async function toggleLike() {
    try {
      const response = await fetch("https://api.trulens.ae/api/likes/add", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: userData.token,
        },
        body: JSON.stringify({ videoId }),
      });
      if (response.ok) {
        hasLiked = !hasLiked;
        fetchLikeCount();
        saveLikeStatus();
      } else {
        // console.error("Failed to toggle like:", response.statusText);
      }
    } catch (error) {
      // console.error("Error toggling like:", error);
    }
  }

  function saveLikeStatus() {
    let likedVideos = JSON.parse(localStorage.getItem("likedVideos")) || {};
    likedVideos[videoId] = hasLiked;
    // localStorage.setItem("likedVideos", JSON.stringify(likedVideos));
  }

  export let show;

  function closeModal() {
    show = false;
  }

  let replyText = "";
  let selectedComment = null;

  async function addReply(commentId) {
    try {
      const response = await fetch(
        "https://api.trulens.ae/api/comments/reply",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: userData.token,
          },
          body: JSON.stringify({ commentId, text: replyText }),
        }
      );
      if (response.ok) {
        fetchCommentsReplies();

        replyText = "";

        selectedComment = null;
      } else {
        // console.error("Failed to add reply:", response.statusText);
      }
    } catch (error) {
      // console.error("Error adding reply:", error);
    }
  }

  onMount(fetchComments);

  const pathSegments = window.location.hash.split("/");
  if (pathSegments.length > 2 && pathSegments[1] === "video") {
    videoId = pathSegments[2];
  }

  onMount(() => {
    userData = JSON.parse(localStorage.getItem("userData"));
  });

  function nameTimestamp(timestamp) {
    const cleanTimestamp = timestamp
      .replace(/\.(mkv|jpg)/, "")
      .replace(/_/g, ":");
    return formatTimestamp(cleanTimestamp);
  }

  function formatTimestamp(timestamp) {
    const date = new Date(timestamp);

    const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];

    const dayName = days[date.getDay()];
    const day = date.getDate();
    const ordinalSuffix = (n) => {
      const s = ["th", "st", "nd", "rd"];
      const v = n % 100;
      return n + (s[(v - 20) % 10] || s[v] || s[0]);
    };
    const monthName = months[date.getMonth()];
    const year = String(date.getFullYear()).slice(-2);

    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12;
    hours = hours ? hours : 12;

    return `${dayName}, ${ordinalSuffix(day)} ${monthName} ${year} ${hours}:${minutes} ${ampm}`;
  }

  async function deleteComment(commentId) {
    confirmationMessage = "Are you sure you want to delete this comment?";
    deletionCallback = () => performDeleteComment(commentId);
    showConfirmation = true;
  }

  async function deleteReply(commentId, replyId) {
    confirmationMessage = "Are you sure you want to delete this reply?";
    deletionCallback = () => performDeleteReply(commentId, replyId);
    showConfirmation = true;
  }

  function performDeleteComment(commentId) {
    fetch("https://api.trulens.ae/api/comments/delete", {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: userData.token,
      },
      body: JSON.stringify({ commentId }),
    })
      .then((response) => {
        if (response.ok) {
          comments = comments.filter((comment) => comment._id !== commentId);
        } else {
          // console.error("Failed to delete comment:", response.statusText);
        }
      })
      .catch((error) => {
        // console.error("Error deleting comment:", error);
      });
  }

  function performDeleteReply(commentId, replyId) {
    fetch("https://api.trulens.ae/api/comments/reply/delete", {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: userData.token,
      },
      body: JSON.stringify({ commentId, replyId }),
    })
      .then((response) => {
        if (response.ok) {
          comments = comments.map((comment) => {
            if (comment._id === commentId) {
              comment.replies = comment.replies.filter(
                (reply) => reply._id !== replyId
              );
            }
            return comment;
          });
        } else {
          // console.error("Failed to delete reply:", response.statusText);
        }
      })
      .catch((error) => {
        // console.error("Error deleting reply:", error);
      });
  }

  let showVerificationModal = false;
  const toggleVerificationModal = () => {
    showVerificationModal = !showVerificationModal;
  };

  let showPostVerificationModal = false;
  const togglePostVerificationModal = () => {
    showPostVerificationModal = !showPostVerificationModal;
  };
</script>

<link
  href="https://unpkg.com/maplibre-gl/dist/maplibre-gl.css"
  rel="stylesheet"
/>

<link
  href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0-beta3/css/all.min.css"
  rel="stylesheet"
/>

<Notification {message} show={showNotification} />
<Header />
<div class="container">
  <div class="video-page">
    <div class="video-player">
      <div class="video-container">
        {#if mediaType === "video"}
          <video class="main-video" controls autoplay src={video.downloadURL}>
            <track kind="captions" />
          </video>
        {:else if mediaType === "image"}
          <img class="main-image" src={video.downloadURL} alt={video.title} />
        {/if}
      </div>

      <div>
        <!-- Like button -->
        {#if userData}
          <button on:click={toggleLike} class="like-button">
            {#if hasLiked}
              <i class="fas fa-thumbs-up"></i>
            {:else}
              <i class="far fa-thumbs-up"></i>
            {/if}
            {likeCount}
          </button>
        {:else}
          <button class="like-button">
            <i class="far fa-thumbs-up"></i>
            {likeCount}
          </button>
        {/if}

        <button
          class="like-button comment-toggle-button"
          on:click={toggleComments}
        >
          <i class="far fa-comments"></i>
        </button>

        <!-- Share button -->
        <button on:click={toggleShareModal} class="like-button share-button">
          <i class="far fa-share-square"></i>
        </button>

        {#if video}
          {#if video.verificationStatus === "Original"}
            <!-- svelte-ignore a11y-click-events-have-key-events -->
            <span
              class="verified"
              on:click={() => {
                togglePostVerificationModal();
              }}>Original</span
            >
            <i
              class="fa fa-check verified"
              aria-hidden="true"
              on:click={() => {
                togglePostVerificationModal();
              }}
            ></i>
          {:else}
            <!-- svelte-ignore a11y-click-events-have-key-events -->
            <span
              class="not-verified"
              on:click={() => {
                togglePostVerificationModal();
              }}>Modified</span
            >
            <i
              class="fa fa-times not-verified"
              aria-hidden="true"
              on:click={() => {
                togglePostVerificationModal();
              }}
            ></i>
          {/if}
        {/if}
        <!-- Share Modal -->
        {#if showShareModal}
          <div class="modal">
            <div class="modal-content">
              <!-- svelte-ignore a11y-click-events-have-key-events -->
              <span class="close" on:click={toggleShareModal}>&times;</span>
              <h2>Share Video Link</h2>

              <div class="social-icons">
                <!-- Add  social icons here -->
              </div>

              <div class="copy-link">
                <input type="text" value={videoUrl} readonly />
                <button on:click={copyVideoLink}>Share Link</button>
              </div>

              {#if video && video.downloadURL}
                <div class="copy-link">
                  <input
                    type="text"
                    value={"https://api.trulens.ae/download/" + video._id}
                    readonly
                  />
                  <button on:click={copyVideoLink2}>Copy Link</button>
                </div>
              {/if}
            </div>
            <!-- svelte-ignore a11y-click-events-have-key-events -->
            <span class="close right" on:click={toggleShareModal}>&times;</span>
          </div>
        {/if}
      </div>

      {#if video}
        <div class="video-info">
          <!-- <h2>
            {#if video.isNamePrivate}
              <i class="fa-solid fa-user-lock"></i>
              <span>{video.alternateName}</span>
            {:else}
              <span>{video.name}</span>
            {/if}
            {#if video.userVerificationStatus === "verified"}
              <i
                class="fas fa-check-circle"
                style="color: green; cursor: pointer;"
                on:click={toggleVerificationModal}
              ></i>
            {:else}
              <i
                class="fas fa-times-circle"
                style="color: red; cursor: pointer;"
                on:click={toggleVerificationModal}
              ></i>
            {/if}
          </h2> -->

          {#if !video.isNamePrivate}
            <div class="profile-header">
              {#if video.profilePicture !== null}
                <!-- svelte-ignore a11y-img-redundant-alt -->
                <img
                  class="profile-picture"
                  src={video.profilePicture}
                  alt="Profile Picture"
                />
              {:else}
                <!-- svelte-ignore a11y-img-redundant-alt -->
                <img
                  class="profile-picture"
                  src="/profile.png"
                  alt="Profile Picture"
                />
              {/if}
              <h2>
                <!-- {video.name} -->
                {#if video.isNamePrivate}
                  <i class="fa-solid fa-user-lock"></i>
                  <span>{video.alternateName}</span>
                {:else}
                  <span>{video.name}</span>
                {/if}
                {#if video.userVerificationStatus === "verified"}
                  <!-- svelte-ignore a11y-click-events-have-key-events -->
                  <i
                    class="fas fa-check-circle"
                    style="color: green; cursor: pointer;"
                    on:click={toggleVerificationModal}
                  ></i>
                {:else}
                  <!-- svelte-ignore a11y-click-events-have-key-events -->
                  <i
                    class="fas fa-times-circle"
                    style="color: red; cursor: pointer;"
                    on:click={toggleVerificationModal}
                  ></i>
                {/if}

                <div class="subscriber-count">
                  <small>{subscriberCount} Subscribers</small>
                </div>
              </h2>
              {#if userData && video.userId !== userData.user._id}
                &nbsp; &nbsp;
                <button
                  class="subscribe-button {isSubscribed
                    ? 'subscribed'
                    : 'subscribe'}"
                  on:click={() => {
                    if (isSubscribed) {
                      showUnsubscribeConfirmation = true;
                    } else {
                      addSubscription();
                    }
                  }}
                  disabled={isCheckingSubscription}
                >
                  {#if isCheckingSubscription}
                    Loading
                  {:else}
                    {isSubscribed ? "Subscribed" : "Subscribe"}
                  {/if}
                </button>
              {/if}
            </div>
          {:else}
            <div class="profile-header">
              <img
                class="profile-picture"
                src="/anonymous.jpg"
                alt="Profile Picture"
              />
              <h2>
                <!-- Logged in -->
                <!-- {video.name} -->
                {#if video.isNamePrivate}
                  <i class="fa-solid fa-user-lock"></i>
                  <span>{video.alternateName}</span>
                {:else}
                  <span>{video.name}</span>
                {/if}
                {#if video.userVerificationStatus === "verified"}
                  <!-- svelte-ignore a11y-click-events-have-key-events -->
                  <i
                    class="fas fa-check-circle"
                    style="color: green; cursor: pointer;"
                    on:click={toggleVerificationModal}
                  ></i>
                {:else}
                  <!-- svelte-ignore a11y-click-events-have-key-events -->
                  <i
                    class="fas fa-times-circle"
                    style="color: red; cursor: pointer;"
                    on:click={toggleVerificationModal}
                  ></i>
                {/if}

                {#if video.alternateName && video.alternateName.toLowerCase() !== "anonymous"}
                  <div class="subscriber-count">
                    <small>{aliasSubscriberCount} Subscribers</small>
                  </div>
                {/if}
              </h2>

              {#if userData && video.alternateName && video.alternateName.toLowerCase() !== "anonymous"}
                &nbsp; &nbsp;
                <button
                  class="subscribe-button {isSubscribed
                    ? 'subscribed'
                    : 'subscribe'}"
                  on:click={() => {
                    if (isSubscribed) {
                      showUnsubscribeConfirmation = true;
                    } else {
                      addAliasSubscription();
                    }
                  }}
                  disabled={isCheckingSubscription}
                >
                  {#if isCheckingSubscription}
                    Loading
                  {:else}
                    {isSubscribed ? "Subscribed" : "Subscribe"}
                  {/if}
                </button>
              {/if}
            </div>
          {/if}

          <h2>
            {video.title}
          </h2>
          <span>
            <h4>
              At: {nameTimestamp(video.originalName)}
            </h4>
          </span>
          <p>
            {#if showFullDescription}
              {video.videoDescription}
              <!-- svelte-ignore a11y-click-events-have-key-events -->
              <span
                class="toggle-description"
                on:click={() => (showFullDescription = false)}
              >
                Read less</span
              >
            {:else}
              {video.videoDescription.length > 50
                ? `${video.videoDescription.slice(0, 50)}...`
                : video.videoDescription}
              {#if video.videoDescription.length > 50}
                <!-- svelte-ignore a11y-click-events-have-key-events -->
                <span
                  class="toggle-description"
                  on:click={() => (showFullDescription = true)}
                >
                  Read more</span
                >
              {/if}
            {/if}
          </p>
          <div class="video-info">
            <div class="tags-container">
              <!-- Example of tags -->
              {#each video.tags as tag}
                <span class="tag">{tag}</span>
              {/each}
            </div>
          </div>
          <br />
        </div>
        <div class="map-container" id="map" style="height: 400px;"></div>
      {/if}
    </div>
    {#if video}
      {#if !video.isNamePrivate}
        <div class="video-list">
          <h2>Related Posts</h2>
          {#if videos.length > 0}
            {#each videos as video}
              <!-- svelte-ignore a11y-media-has-caption -->
              <!-- svelte-ignore a11y-click-events-have-key-events -->
              <div
                class="video-card-others"
                on:click={() => handleVideoClick(video)}
              >
                {#if video.mimeType.startsWith("video/")}
                  <video
                    src={video.downloadURL}
                    class="video-card-others-video"
                  />
                {:else if video.mimeType.startsWith("image/")}
                  <img
                    src={video.downloadURL}
                    alt={video.title}
                    class="video-card-others-img"
                  />
                {/if}
                <div class="video-details">
                  <div class="profile-info">
                    <img
                      class="rp-profile-picture"
                      src={video.userId.profilePicture || "/profile.png"}
                      alt="Profile Picture"
                    />
                    <span><b>{video.userId.name}</b></span>
                  </div>
                  <h3>{video.title}</h3>
                </div>
              </div>
            {/each}
          {:else}
            <p>No related posts found.</p>
          {/if}
        </div>
      {:else}
        <div class="video-list">
          <h2>Related Posts</h2>
          {#if videos.length > 0}
            {#each videos as video}
              <!-- svelte-ignore a11y-click-events-have-key-events -->
              <div
                class="video-card-others"
                on:click={() => handleVideoClick(video)}
              >
                {#if video.mimeType.startsWith("video/")}
                  <!-- svelte-ignore a11y-media-has-caption -->
                  <video
                    src={video.downloadURL}
                    class="video-card-others-video"
                  />
                {:else if video.mimeType.startsWith("image/")}
                  <img
                    src={video.downloadURL}
                    alt={video.title}
                    class="video-card-others-img"
                  />
                {/if}
                <div class="video-details">
                  <div class="profile-info">
                    <!-- svelte-ignore a11y-img-redundant-alt -->
                    <img
                      class="rp-profile-picture"
                      src="/anonymous.jpg"
                      alt="Profile Picture"
                    />
                    <span><b>{video.alternateName}</b></span>
                  </div>
                  <h3>{video.title}</h3>
                </div>
              </div>
            {/each}
          {:else if relatedVideosMessage}
            <p class="no-posts-message">{relatedVideosMessage}</p>
          {:else}
            <p>No related posts found.</p>
          {/if}
        </div>
      {/if}
    {/if}
  </div>

  {#if userData}
    <div id="comments-section">
      <div class="">
        <br />
        <textarea
          class="txt-area"
          bind:value={newComment}
          placeholder="Add a comment"
        ></textarea>
        <br />
        <button on:click={addComment} class="comment-button">
          <i class="fas fa-paper-plane"></i> Submit
        </button>

        <!-- Display comments -->
        {#if comments && comments.length > 0}
          <div class="comments-container">
            <h3>Comments</h3>
            {#each comments as comment}
              <div class="comment-card">
                <div class="comment-header">
                  <!-- Profile picture to the left of the username -->
                  <div class="profile-info">
                    <img
                      class="cr-profile-picture"
                      src={comment.userId.profilePicture || "/profile.png"}
                      alt="Profile Picture"
                    />
                    <b>{comment.userId.name}</b>
                  </div>
                  <span style="font-size: 13px;"
                    >{formatTimestamp(comment.createdAt)}</span
                  >
                </div>
                <p>{comment.text}</p>

                <!-- Edit button for comments -->
                {#if comment.userId._id === userData.user._id}
                  <div class="edit-delete-container">
                    <button
                      class="edit-comment"
                      on:click={() => openEditModal("comment", comment)}
                    >
                      <i class="fas fa-edit" style="color: green;"></i>
                    </button>
                    <button
                      class="delete-comment"
                      on:click={() => deleteComment(comment._id)}
                    >
                      <i class="fas fa-trash" style="color: red;"></i>
                    </button>
                  </div>
                {/if}

                &nbsp;

                <button
                  on:click={() =>
                    (selectedComment =
                      selectedComment === comment._id ? null : comment._id)}
                  class="reply-close"
                >
                  {#if selectedComment === comment._id}
                    <i class="fa fa-close"></i>
                  {:else}
                    <i class="fa fa-reply" aria-hidden="true"></i>
                  {/if}
                </button>

                {#if selectedComment === comment._id}
                  <div class="reply-form">
                    <textarea
                      class="txt-area"
                      bind:value={replyText}
                      placeholder="Reply to this comment"
                    ></textarea>
                    <div class="reply-actions">
                      <button
                        on:click={() => addReply(comment._id)}
                        class="reply-button"
                      >
                        Reply
                      </button>
                    </div>
                  </div>
                {/if}

                <!-- Display and edit replies -->
                {#if comment.replies && comment.replies.length > 0}
                  <div class="replies-container">
                    {#if comment.showReplies}
                      <button
                        on:click={() => (comment.showReplies = false)}
                        class="hide-replies-button"
                      >
                        <i class="fas fa-angle-up"></i> &nbsp; {comment.replies
                          .length} Replies
                      </button>
                      {#each comment.replies as reply}
                        <div class="reply-card">
                          <div class="comment-header">
                            <!-- Profile picture to the left of the username -->
                            <div class="profile-info">
                              <img
                                class="cr-profile-picture"
                                src={reply.userId?.profilePicture ||
                                  "/profile.png"}
                                alt="Profile Picture"
                              />
                              <b>{reply.userId?.name}</b>
                            </div>
                            <span style="font-size: 13px;"
                              >{formatTimestamp(reply.timestamp)}</span
                            >
                          </div>
                          <p>{reply.text}</p>

                          <!-- Edit button for replies -->
                          {#if reply.userId._id === userData.user._id}
                            <div class="edit-delete-container">
                              <button
                                class="edit-reply"
                                on:click={() =>
                                  openEditModal("reply", comment._id, reply)}
                              >
                                <i class="fas fa-edit" style="color: green;"
                                ></i>
                              </button>
                              <button
                                class="delete-reply"
                                on:click={() =>
                                  deleteReply(comment._id, reply._id)}
                              >
                                <i class="fas fa-trash" style="color: red;"></i>
                              </button>
                            </div>
                          {/if}
                        </div>
                      {/each}
                    {:else}
                      <button
                        on:click={() => (comment.showReplies = true)}
                        class="view-replies-button"
                      >
                        <i class="fas fa-angle-down"></i> &nbsp; {comment
                          .replies.length} Replies
                      </button>
                    {/if}
                  </div>
                {/if}
              </div>
            {/each}
          </div>
        {/if}
      </div>
    </div>
  {:else}
    <div id="comments-section" class="">
      <div class="">
        <br />
        <!-- Display comments -->
        {#if comments && comments.length > 0}
          <div class="comments-container">
            <h3>Comments</h3>
            {#each comments as comment}
              <div class="comment-card">
                <div class="comment-header">
                  <!-- Profile picture to the left of the username -->
                  <div class="profile-info">
                    <img
                      class="cr-profile-picture"
                      src={comment.userId.profilePicture || "/profile.png"}
                      alt="Profile Picture"
                    />
                    <b>{comment.userId.name}</b>
                  </div>
                  <span style="font-size: 13px;"
                    >{formatTimestamp(comment.createdAt)}</span
                  >
                </div>
                <p>{comment.text}</p>
                <!-- <p>{formatTimestamp(comment.createdAt)}</p> -->
                <!-- Display replies -->
                {#if comment.replies && comment.replies.length > 0}
                  <div class="replies-container">
                    {#if comment.showReplies}
                      <button
                        on:click={() => (comment.showReplies = false)}
                        class="hide-replies-button"
                      >
                        <i class="fas fa-angle-up"></i> &nbsp; {comment.replies
                          .length} Replies
                      </button>
                      {#each comment.replies as reply}
                        <div class="reply-card">
                          <div class="comment-header">
                            <!-- Profile picture to the left of the username -->
                            <div class="profile-info">
                              <img
                                class="cr-profile-picture"
                                src={reply.userId?.profilePicture ||
                                  "/profile.png"}
                                alt="Profile Picture"
                              />
                              <b>{reply.userId?.name}</b>
                            </div>
                            <span style="font-size: 13px;"
                              >{formatTimestamp(reply.timestamp)}</span
                            >
                          </div>
                          <p>{reply.text}</p>
                          <!-- <p>{formatTimestamp(reply.timestamp)}</p> -->
                        </div>
                      {/each}
                    {:else}
                      <button
                        on:click={() => (comment.showReplies = true)}
                        class="view-replies-button"
                      >
                        <i class="fas fa-angle-down"></i> &nbsp; {comment
                          .replies.length} Replies
                      </button>
                    {/if}
                  </div>
                {/if}
              </div>
            {/each}
            {#if loading}
              <div class="spinner">
                <i class="fa fa-spinner fa-spin"></i> Loading...
              </div>
            {/if}
          </div>
        {:else}
          <p>No comments yet.</p>
        {/if}
      </div>
    </div>
  {/if}
  {#if showEditModal}
    <div class="modal">
      <div class="modal-content">
        <!-- svelte-ignore a11y-click-events-have-key-events -->
        <span class="close" on:click={closeEditModal}>&times;</span>
        <h2>Edit {editType}</h2>
        <input type="text" class="input-cmnt" bind:value={editText} />
        <br />
        <button on:click={submitEdit} class="edit-button">Save</button>
      </div>
    </div>
  {/if}
  {#if showConfirmation}
    <Confirmation
      message={confirmationMessage}
      confirmAction={() => {
        deletionCallback();
        showConfirmation = false;
      }}
      cancelAction={() => {
        showConfirmation = false;
      }}
    />
  {/if}

  {#if showVerificationModal}
    <div class="modal">
      <div class="modal-content">
        <!-- svelte-ignore a11y-click-events-have-key-events -->
        <span class="close" on:click={toggleVerificationModal}>&times;</span>
        <h2>
          {video.userVerificationStatus === "verified"
            ? "Verified"
            : "Not Verified"}
        </h2>
        <p>
          {video.userVerificationStatus === "verified"
            ? "This post is verified with the user's personal encrypted digital signature."
            : "This post is not verified with the user's personal encrypted digital signature."}
        </p>
      </div>
    </div>
  {/if}

  {#if showUnsubscribeConfirmation}
    <div class="modal-s">
      <div class="modal-content-s">
        <!-- Close button -->
        <!-- svelte-ignore a11y-click-events-have-key-events -->
        <span
          class="close-s"
          on:click={() => (showUnsubscribeConfirmation = false)}>&times;</span
        >

        <p>
          Are you sure you want to remove the subscription to
          {#if video.isNamePrivate}
            {video.alternateName}?
          {:else}
            {video.name}?
          {/if}
        </p>

        <div class="modal-actions-s">
          <button
            class="cancel-button-s"
            on:click={() => (showUnsubscribeConfirmation = false)}
          >
            Cancel
          </button>

          {#if video.isNamePrivate}
            <button
              class="confirm-button-s"
              on:click={() => {
                removeAliasSubscription();
                showUnsubscribeConfirmation = false;
              }}
            >
              Unsubscribe
            </button>
          {:else}
            <button
              class="confirm-button-s"
              on:click={() => {
                removeSubscription();
                showUnsubscribeConfirmation = false;
              }}
            >
              Unsubscribe
            </button>
          {/if}
        </div>
      </div>
    </div>
  {/if}

  {#if showPostVerificationModal}
    <div class="modal">
      <div class="modal-content">
        <!-- svelte-ignore a11y-click-events-have-key-events -->
        <span class="close" on:click={togglePostVerificationModal}>&times;</span
        >
        <h2>
          {video.verificationStatus === "Original" ? "Original" : "Modified"}
        </h2>
        <p>
          {video.verificationStatus === "Original"
            ? "This post is verified to be untampered, unedited, and not generated by any generative AI tool."
            : "This post has been verified as tampered, edited, or generated by a generative AI tool."}
        </p>
      </div>
    </div>
  {/if}
</div>

<style>
  .map-container {
    width: 100%;
    margin-top: 20px;
    border: 1px solid #ccc;
    border-radius: 8px;
    overflow: hidden;
  }

  .profile-header {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
  }

  .profile-info {
    margin-top: 5px;
    display: flex;
    align-items: center;
  }

  .profile-picture {
    width: 60px;
    height: 60px;
    border-radius: 50%;
    object-fit: cover;
    margin-right: 15px;
    border: 2px solid #ccc;
  }

  .cr-profile-picture {
    width: 25px;
    height: 25px;
    border-radius: 50%;
    object-fit: cover;
    border: 2px solid #ccc;
    margin-right: 10px;
  }

  .user-details {
    display: flex;
    flex-direction: column;
  }

  .verified {
    color: green;
    margin-left: 10px;
    cursor: pointer;
  }

  .not-verified {
    color: red;
    margin-left: 10px;
    cursor: pointer;
  }

  .subscribe-button {
    background-color: #ff3c82;
    color: white;
    border: none;
    padding: 8px 16px;
    border-radius: 5px;
    font-size: 14px;
    cursor: pointer;
    margin-top: 5px;
  }

  .subscribe-button:hover {
    background-color: #ff196d;
  }

  .subscribe-button.subscribed {
    background-color: rgba(31, 31, 31, 0.7);
  }

  .subscribe-button.subscribed:hover {
    background-color: rgba(15, 15, 15, 0.7);
  }

  .verified {
    color: green;
  }

  .not-verified {
    color: red;
  }

  .main-image {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: contain;
  }

  .container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 20px;
  }

  .video-page {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    margin-top: 40px;
  }

  .video-container {
    background-color: #000000;
    position: relative;
    width: 700px;
    padding-bottom: 56.25%;
    overflow: hidden;
  }

  .main-video {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: contain;
  }

  .rotate-90 {
    transform: rotate(90deg);
    transform-origin: center;
  }

  .video-info {
    width: 700px;
    text-align: left;
  }

  .video-info p {
    font-size: 16px;
  }

  .video-info .tags-container {
    display: flex;
    flex-wrap: wrap;
    gap: 5px;
    margin-top: 10px;
  }

  .video-info .tag {
    background-color: #eee;
    border-radius: 5px;
    padding: 5px 10px;
    font-size: 12px;
    color: #333;
    display: inline-block;
    max-width: 100%;
    text-overflow: ellipsis;
    overflow: hidden;
  }

  .edit-delete-container {
    display: inline-flex;
    gap: 10px;
  }

  .edit-comment,
  .delete-comment,
  .reply-close {
    background: none;
    border: none;
    cursor: pointer;
    padding: 0;
  }

  .edit-comment:focus,
  .delete-comment:focus .reply-close:focus {
    outline: none;
  }

  .edit-reply,
  .delete-reply {
    background: none;
    border: none;
    cursor: pointer;
    padding: 0;
  }

  .edit-reply:focus,
  .delete-reply:focus {
    outline: none;
  }

  .video-info h2 {
    font-size: 24px;
  }

  .toggle-description {
    color: blue;
    cursor: pointer;
  }

  .video-list {
    margin-top: 0px;
    width: 40%;
    flex-grow: 1;
    margin-left: 20px;
  }

  .video-list h2 {
    font-size: 20px;
    margin-bottom: 10px;
  }

  .video-card-others {
    display: flex;
    margin-bottom: 20px;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    cursor: pointer;
    align-items: center;
  }

  .video-card-others-video,
  .video-card-others-img {
    border-radius: 10px;
    border: 1px solid black;
    width: 35%;
    height: 100%;
    object-fit: cover;
  }

  .rp-profile-picture {
    width: 25px;
    height: 25px;
    border-radius: 50%;
    margin-right: 10px;
  }

  .video-details {
    padding: 10px;
  }

  .video-details h3 {
    font-size: 12px;
    margin-top: 6px;
    /* margin: 0; */
  }

  .video-details p {
    font-size: 14px;
    margin: 5px 0 0;
  }

  .edit-button {
    margin-top: 10px;
    background-color: #ff3c82;
    border: none;
    color: rgb(0, 0, 0);
    padding: 10px 20px;
    text-align: center;
    text-decoration: none;
    display: inline-block;
    font-size: 16px;
    margin-right: 10px;
    cursor: pointer;
    border-radius: 5px;
    transition: background-color 0.3s ease;
  }
  .edit-button:hover {
    background-color: #b683d4;
  }

  .like-button {
    margin-top: 10px;
    background-color: #ff3c82;
    border: none;
    color: rgb(0, 0, 0);
    padding: 10px 20px;
    text-align: center;
    text-decoration: none;
    display: inline-block;
    font-size: 16px;
    margin-right: 10px;
    cursor: pointer;
    border-radius: 5px;
    transition: background-color 0.3s ease;
  }

  .like-button:hover {
    background-color: #b683d4;
  }

  .like-count {
    font-size: 16px;
    color: #555;
  }

  .comments-container {
    margin-top: 20px;
  }

  .comment-card {
    margin-bottom: 10px;
    border-bottom: 1px solid #ccc;
    padding-bottom: 10px;
    width: 700px;
  }

  .comment-card p {
    margin: 5px 0;
  }
  .txt-area {
    width: 700px;
  }

  .input-cmnt {
    width: 100%;
  }

  .reply-card {
    margin-left: 20px;
    padding-left: 10px;
    border-left: 2px solid #ccc;
    margin-top: 5px;
  }

  .comment-button,
  .reply-button {
    margin-top: 10px;
    background-color: #ff3c82;
    border: none;
    color: white;
    padding: 10px 20px;
    text-align: center;
    text-decoration: none;
    display: inline-block;
    font-size: 16px;
    cursor: pointer;
    border-radius: 5px;
  }

  .show-reply-form {
    margin-top: 10px;
    background-color: #717171;
    border: none;
    color: white;
    padding: 5px 10px;
    text-align: center;
    text-decoration: none;
    display: inline-block;
    font-size: 16px;
    cursor: pointer;
    border-radius: 5px;
  }

  .reply-form {
    display: flex;
    align-items: center;
  }

  .reply-actions {
    display: flex;
  }

  .hide-reply-form-button,
  .reply-button {
    margin-left: 10px;
  }

  .comment-button:hover,
  .reply-button:hover:hover {
    background-color: #b683d4;
  }

  .show-reply-form:hover {
    background-color: #ff0000;
  }

  .reply-form {
    margin-top: 10px;
  }

  .hide-replies-button,
  .view-replies-button {
    margin-top: 10px;
    background-color: #3498db;
    border: none;
    color: white;
    padding: 5px 10px;
    text-align: center;
    text-decoration: none;
    display: inline-block;
    font-size: 14px;
    cursor: pointer;
    border-radius: 3px;
  }

  .hide-replies-button:hover,
  .view-replies-button:hover {
    background-color: #2980b9;
  }

  .modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 999;
  }

  .modal-content {
    background-color: #fff;
    padding: 20px;
    border-radius: 8px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
    position: relative;
    width: 90%;
    max-width: 500px;
  }

  .close {
    position: absolute;
    top: 10px;
    right: 10px;
    font-size: 24px;
    cursor: pointer;
  }

  .copy-link {
    display: flex;
    align-items: center;
    margin-top: 15px;
  }

  .copy-link input {
    flex-grow: 1;
    margin-right: 10px;
    padding: 10px;
  }

  .copy-link button {
    padding: 10px 20px;
    background-color: #ff3c82;
    border: none;
    color: white;
    cursor: pointer;
    border-radius: 5px;
  }

  .copy-link button:hover {
    background-color: #b683d4;
  }

  .social-icons {
    margin-bottom: 10px;
  }

  .social-icons i {
    font-size: 24px;
    margin-right: 10px;
    cursor: pointer;
  }

  /* .copy-link {
    display: flex;
    align-items: center;
  }

  .copy-link input {
    flex-grow: 1;
    margin-right: 10px;
  }

  .copy-link button {
    padding: 10px 20px;
    background-color: #ff3c82;
    border: none;
    color: white;
    cursor: pointer;
    border-radius: 5px;
  }

  .copy-link button:hover {
    background-color: #b683d4;
  } */

  .close:hover,
  .close:focus {
    color: #000;
    text-decoration: none;
    cursor: pointer;
  }

  .spinner {
    text-align: center;
  }

  .subscriber-count {
    font-size: 0.9rem;
    color: gray;
  }

  .modal-s {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .modal-content-s {
    background: white;
    padding: 20px;
    width: 35%;
    border-radius: 5px;
    font-weight: bold;
  }

  .modal-actions-s {
    display: flex;
    /* justify-content: flex-end; */
    justify-content: space-between;
    align-items: center;
    margin-top: 20px;
  }

  .confirm-button-s {
    background-color: red;
    color: white;
    padding: 5px 10px;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    /* margin-left: 18px; */
  }

  .cancel-button-s {
    background-color: gray;
    color: white;
    padding: 5px 10px;
    border: none;
    border-radius: 5px;
    cursor: pointer;
  }

  .close-s {
    position: absolute;
    top: 10px;
    right: 10px;
    cursor: pointer;
  }

  @media only screen and (max-width: 450px) {
    .subscriber-count {
      font-size: 0.7rem;
    }

    .modal-content-s {
      width: 85%;
      max-width: 350px;
    }

    .container {
      padding: 10px;
    }

    .video-page {
      flex-direction: column;
    }

    .video-container {
      width: 100%;
      padding-bottom: 56.25%;
    }

    .video-info {
      width: 100%;
    }

    .video-info p {
      font-size: 14px;
    }

    .video-info .tags-container {
      display: flex;
      flex-wrap: wrap;
      gap: 5px;
      margin-top: 10px;
    }

    .video-info .tag {
      background-color: #eee;
      border-radius: 5px;
      padding: 5px 10px;
      font-size: 12px;
      color: #333;
      display: inline-block;
      max-width: 100%;
      text-overflow: ellipsis;
      overflow: hidden;
    }

    .video-info h2 {
      font-size: 16px;
    }

    .video-list {
      margin-top: 60px;
      width: 100%;
      margin-left: 0;
    }

    .video-card-others {
      display: flex;
      align-items: start;
      margin-bottom: 20px;
      align-items: center;
    }

    .rp-profile-picture {
      width: 20px;
      height: 20px;
    }

    .video-card-others-video,
    .video-card-others-img {
      width: 35%;
      height: 100%;
      object-fit: cover;
    }

    .video-details {
      padding: 10px;
    }

    .comment-card {
      width: 100%;
    }

    .txt-area {
      width: 100%;
    }

    .modal-content {
      width: 80%;
      padding: 15px;
    }

    .close {
      font-size: 20px;
    }

    .copy-link button {
      font-size: 14px;
      padding: 8px 15px;
    }

    .copy-link input {
      font-size: 14px;
    }

    .profile-picture {
      width: 30px;
      height: 30px;
      margin-right: 7px;
    }

    .subscribe-button {
      padding: 4px 8px;
      font-size: 10px;
    }
  }
</style>
